import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[appStickyContainer]',
})
export class StickyContainerDirective {
  @Input() yOffset: number = 0;
  @Input() enabled = false;

  private isSticky = false;

  get element(): HTMLElement {
    return this.host.nativeElement;
  }

  constructor(private host: ElementRef) {}

  @HostListener('window:scroll', ['$event'])
  checkScroll() {
    this.isSticky = window.pageYOffset >= this.yOffset;
    if (this.enabled && this.isSticky) {
      this.addSticky();
    } else {
      this.removeSticky();
    }
  }

  addSticky() {
    this.element.style.position = 'fixed';
    this.element.style.top = '0';
  }

  removeSticky() {
    this.element.style.position = 'static';
  }
}
